import Vue from 'vue';
import utils from '~/utils/utils';
import { defaultLoansState } from './state';

export default {
    commitFilter(state, payload) {
        state.loans.params = { ...state.loans.params, ...payload };
    },

    commitFilterTerm(state, payload) {
        Vue.set(state.loans.params, payload.param, payload.value);
    },

    commitDefaultFilter(state, payload) {
        state.default_filter = Object.assign(state.default_filter, payload);
    },

    commitDefaultPipelineFilter(state, payload) {
        state.default_pipeline_filter = Object.assign(state.default_pipeline_filter, payload);
    },

    commitDefaultFundedFilter(state, payload) {
        state.default_funded_filter = Object.assign(state.default_funded_filter, payload);
    },

    resetFilterToDefault(state, payload) {
        if (payload === 'pipeline') {
            state.loans.params = Object.assign(state.loans.params, state.default_pipeline_filter);
        } else if (payload === 'funded') {
            state.loans.params = Object.assign(state.loans.params, state.default_funded_filter);
        } else {
            state.loans.params = Object.assign(state.loans.params, state.default_filter);
        }
    },

    updateSearch(state, payload) {
        state.loans.params.search = payload;
    },

    // LOADING STATE
    updateLoadingState(state, payload) {
        state[payload.loading] = payload.state;
    },

    // UPDATE DATA
    updateSelected(state, payload) {
        state.selected = payload;
    },

    concatPage(state, payload) {
        state.loans = state.loans.concat(payload.loans);
        state.funded_stats = payload.funded_stats;
        state.pipeline_stats = payload.pipeline_stats;
        state.bar_chart = payload.bar_chart;
        state.total = payload.recordsTotal;
        state.meta = payload.meta;
    },

    resetLoans(state, payload) {
        state.loans = [];
    },

    getLoans(state, payload) {
        Vue.set(state, 'loans', payload.loans);
        state.funded_stats = payload.funded_stats;
        state.pipeline_stats = payload.pipeline_stats;
        state.bar_chart = payload.bar_chart;
        state.total = payload.recordsTotal;
        state.meta = payload.meta;
    },

    updateLoanStats(state, payload) {
        state.funded_stats = payload.stats;
        state.pipeline_stats = payload.stats;
        state.bar_chart = payload.bar_chart;
    },

    getLoanFormData(state, payload) {
        state.loan_statuses = payload.loan_statuses;
        state.loan_programs = payload.loan_programs;
        state.loan_types = payload.loan_types;
        state.loan_purposes = payload.loan_purposes;
        state.property_types = payload.property_types;
        state.occupancies = payload.occupancies;
        state.account_classifications = payload.account_classifications;
        state.origination_fee_data_type = payload.origination_fee_data_type;
        state.participant_roles = payload.participant_roles;
        state.whitelisted_participant_roles = payload.whitelisted_participant_roles;

        if (payload.pipeline_saved_filters) {
            state.default_pipeline_filter = Object.assign(
                state.default_pipeline_filter,
                payload.pipeline_saved_filters.filters,
            );
        }

        if (payload.funded_saved_filters) {
            state.default_funded_filter = Object.assign(
                state.default_funded_filter,
                payload.funded_saved_filters.filters,
            );
        }
    },

    commitBuyersAgents(state, payload) {
        state.buyers_agents = payload.data;
    },

    commitSellersAgents(state, payload) {
        state.sellers_agents = payload.participants;
    },

    commitSettlementAgents(state, payload) {
        state.settlement_agents = payload.participants;
    },

    commitAttorneys(state, payload) {
        state.attorneys = payload.participants;
    },

    deleteLoan(state, payload) {
        const loanIndex = state.loans.tableData.findIndex((item) => item.id == payload.id);

        state.loans.tableData.splice(loanIndex, 1);
    },

    updateParticipantParam(state, payload) {
        if (!state[payload.field]) {
            Vue.set(state, payload.field, payload.data.data);
        } else {
            state[payload.field] = payload.data.data;
        }
    },

    updateModalState(state, payload) {
        Object.assign(state.modalState, payload);
    },

    updateLoanParticipants(state, payload) {
        state.loan_participants = payload;
    },

    updateLoanParticipantsIsLoading(state, payload) {
        state.loanParticipantsIsLoading = payload;
    },

    setPushServices(state, payload) {
        state.push_services = payload.data;
    },

    sendEmail(state, payload) {},

    emailLoanStatus(state, payload) { },
};
